import clsx from 'clsx';
import React from 'react';

type NavItemListProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLUListElement>,
  HTMLUListElement
>;

const NavItemList = ({ className, ...rest }: NavItemListProps) => (
  <ul className={clsx(className, 'm-0 list-none p-0')} {...rest} />
);

export default NavItemList;
